module.exports = __webpack_public_path__ + "img/2248.783bfadb.gif";